import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import { recordIntent, ADD_DEV_RPS } from '../../../lib/appcenterIntent';
import { CHECKOUT } from '../../../lib/constants';
import {
  fireDetailsPageComponentFailureFpti,
  parseData,
  preventTabNabbing
} from '../../../lib/helpers';

const DetailsCTA = ({
  componentContent,
  handleClickFPTI,
  fptiImpression,
  app
}) => {
  const { cta, title } = componentContent;
  const parsedCta = parseData(cta);

  const handleClick = (fptiLink, url) => {
    handleClickFPTI(fptiLink);
    if (
      componentContent.toolKey === CHECKOUT &&
      fptiLink === 'add_your_developer'
    ) {
      rpsRecordIntent();
    }
    window.open(url, '_blank', `${preventTabNabbing(url)}`);
  };

  const rpsRecordIntent = () => {
    recordIntent({
      csrf: app.csrf,
      productArr: [ADD_DEV_RPS]
    });
  };

  if (!parsedCta?.length) {
    fireDetailsPageComponentFailureFpti({
      data: { cta },
      componentName: 'DetailsCTASection',
      fptiImpression
    });
    return null;
  }

  return (
    <section id="details-cta">
      <div className="detail-cta-title">
        <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
      </div>
      <div className="details-cta-container">
        {parsedCta.map((value, i) => (
          <div key={`details-cta-${i}`} className="details-cta-container-item">
            <h3>{value.title}</h3>
            <p className="font-size-p">{value.subtitle}</p>
            <Button
              onClick={() => handleClick(value.fptiLinkName, value.url)}
              secondary
            >
              {value.text}
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

DetailsCTA.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  app: PropTypes.object,
  fptiImpression: PropTypes.func.isRequied
};

export default DetailsCTA;
